var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicDisabled1 = function SvgMicDisabled1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.87 32.87"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mic-disabled1_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.74px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic-disabled1_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mic-disabled1_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mic-disabled1_svg__cls-1",
    d: "M1.37 1.37 31.5 31.5M12.33 12.33v4.11a4.11 4.11 0 0 0 7 2.9m1.2-6.54V5.48a4.11 4.11 0 0 0-8.13-.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mic-disabled1_svg__cls-1",
    d: "M23.28 23.22a9.59 9.59 0 0 1-16.43-6.78V13.7m19.15 0v2.74a9.46 9.46 0 0 1-.15 1.68M16.43 26.03v5.47M10.96 31.5h10.95"
  })))));
};
export default SvgMicDisabled1;